import { createContext, useContext, useMemo } from 'react';

const BatchFileImportContext = createContext({
  statusOptions: [],
});

export function BatchFileImportProvider({ children, statusOptions }) {
  const contextValue = useMemo(() => ({ statusOptions }), [statusOptions]);

  return (
    <BatchFileImportContext.Provider value={contextValue}>
      {children}
    </BatchFileImportContext.Provider>
  );
}

export function useBatchFileImportContext() {
  return useContext(BatchFileImportContext);
}
